import { Link } from '@subaio/components'
import { logger } from '@subaio/utils'

import { asContainer } from 'lib/container'

import { Doc } from 'components/Layout'

type Params = {
	mrIid: string
}

type SpecReference = {
	scope: 'internal' | 'external'
	apiName: string
	version: string
	title: string
}

type State = {
	specs?: Array<SpecReference>
}

export const container = asContainer<State, Params>()({
	path: '/internal/apis/review/:mrIid',
	title: 'Review API specs',
	authentication: { type: 'public' },
	initialize: async ({ mrIid }) => {
		try {
			const response = await fetch(`/api/internal/review/${encodeURIComponent(mrIid)}`, { cache: 'no-cache' })
			if (!response.ok) {
				throw new Error((await response.text()) || `The API specs could not be loaded (HTTP ${response.status}).`)
			}

			return { specs: (await response.json()) as Array<SpecReference> }
		} catch (error) {
			logger.error(error)
			return {}
		}
	},
	Running: ({ mrIid, specs }) => (
		<Doc showTableOfContents={false}>
			<div>
				{specs ? (
					specs.length > 0 ? (
						(['external', 'internal'] as const).map((scope) => {
							const scopeSpecs = specs.filter((spec) => spec.scope === scope)
							if (scopeSpecs.length === 0) return null

							return (
								<section key={scope}>
									<h2>{scope === 'external' ? 'External' : 'Internal'} API specs</h2>
									<ul>
										{scopeSpecs.map(({ apiName, version, title }) => (
											<li key={`${scope}/${apiName}/${version}`}>
												<Link name='Internal/Apis/Viewer' params={{ mrIid, scope, apiName, version }}>
													{title}
												</Link>
											</li>
										))}
									</ul>
								</section>
							)
						})
					) : (
						<p>No API specs are available for this merge request.</p>
					)
				) : (
					<p>The API specs could not be loaded.</p>
				)}
			</div>
		</Doc>
	),
})
